import { List } from "antd";
import styled from "styled-components";
import { theme } from "../../../config";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.custom.background};
  padding: 57px 83px 15px 83px;
  @media ${theme.breakpoints.mobileAndTablet} {
    padding: 25px 0 15px 16px;
  }
  overflow: auto;
`;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin-bottom: 1em;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 22px;
    line-height: 26px;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${theme.colors.white};
  margin-bottom: 45px;
`;

export const StyledList = styled(List)`
  .ant-list-items {
    background: ${theme.colors.white};
  }

  .ant-list-pagination {
    text-align: center;

    .ant-pagination-item:not(.ant-pagination-item-active),
    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link,
    .ant-select:not(.ant-select-customize-input) .ant-select-selector,
    .ant-pagination-disabled .ant-pagination-item-link,
    .ant-pagination-disabled:hover .ant-pagination-item-link,
    .ant-pagination-disabled:focus-visible .ant-pagination-item-link {
      border: 2px solid ${theme.colors.custom.darkblue3};
      border-radius: 4px;
    }

    .ant-pagination-disabled .ant-pagination-item-link,
    .ant-pagination-disabled:hover .ant-pagination-item-link,
    .ant-pagination-disabled:focus-visible .ant-pagination-item-link {
      border: 2px solid ${theme.colors.grey};
    }
    .ant-pagination-item-link {
      .ant-pagination-disabled {
        border: 2px solid #273049;
      }
      .anticon-right,
      .anticon-left {
        vertical-align: 0;
      }
    }

    .ant-pagination-item:not(.ant-pagination-item-active) {
      display: none;
    }
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev {
      display: none;
    }
  }
`;

export const ListItem = styled.div<{ isRead?: boolean }>`
  display: flex;
  flex-direction: row;
  min-height: 50px;
  height: 100%;
  padding: 1em;
  cursor: pointer;
  border-bottom: 1px solid #D9D9D9;
  gap: .5em;
  align-items: center;
  ${({ isRead }) => isRead ? 'background: #F5F5F5' : ''};
  font-weight: ${({ isRead }) => isRead ? '400' : 'bold'};

  :hover {
    background: rgba(0,0,0,.05);
  }
`;

export const ListIcon = styled.img`
  height: 20px;
  width: 20px;
  margin-right: .5em;
`;

export const Text = styled.div`
  font-size: 16px;
  line-height: 18px;
  color: #111111;
  display: flex;
  flex: 1;
`;

export const Helper = styled.div`
  color: #828282;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
`;